import { ChakraProvider } from "@chakra-ui/react"
import React from "react"
import theme from "../../components/common/chakra-theme"
import Footer from "../../components/footer"
import SEO from "../../components/seo"

const Page = () => {
    const gettingStartedText =
        "Take control of your media lifecycle with ImageKit";

    const primaryCTALink = "/registration";
    const primaryCTAText = "Start my free plan";
    const secondaryCTALink = "/contact-us";
    const secondaryCTAText = "Talk to us";
    const showContactUs = true;

    return (
        <ChakraProvider theme={theme}>
            <SEO
                title="Footer"
                description="Footer for ImageKit.io website"
                meta={[
                    {
                        name: "robot",
                        content: "noindex",
                    },
                ]}
            />
            <Footer
                gettingStartedText={"Free until you’re ready to upgrade to the Premium plan"}
                primaryCTALink={primaryCTALink}
                primaryCTAText={primaryCTAText}
                showContactUs={true}
                secondaryCTALink={secondaryCTALink}
                usingInFrame={true}
                secondaryCTAText={secondaryCTAText}>
            </Footer>
        </ChakraProvider>
    )
}

export default Page
